import { lazy, useEffect, useState } from "react"
import Spinner from "../../components/Spinner"
import jwtDecode from "jwt-decode"
import { getBookingLight } from "../../API/API"

const StudentCurriculum = lazy(() => import("../Curriculum/Curriculum"))
const StudentExtendedCurriculum = lazy(() => import("../Curriculum/ExtendedCurriculum"))
const ParentCurriculum = lazy(() =>
  import("../ParentPortal/Curriculum/ParentCurriculum")
)
const AdminCurriculum = lazy(() =>
  import("../operations/curriculum/Curriculum")
)

const CurriculumType = {
  None: "None",
  StudentNormal: "StudentNormal",
  StudentExtended: "StudentExtended",
  Parent: "Parent",
  Admin: "Admin"
}

export default function RootCurriculum() {
  const [curriculumType, setCurriculumType] = useState(CurriculumType.None)

  useEffect(() => {
    const decodedToken = jwtDecode(localStorage.getItem("token"))
    const decodedRole = decodedToken.role
    
    if(decodedRole === "Student") 
    {
      getBookingLight().then(res => {
        const { shouldSeeExtendedCurriculum } = res.data.data
        setCurriculumType(shouldSeeExtendedCurriculum ? CurriculumType.StudentExtended : CurriculumType.StudentNormal)
      })
      .catch(err => {
        console.log(err)
      })
    }
    else if(decodedRole === "Parent")
    {
      setCurriculumType(CurriculumType.Parent)
    }
    else if(decodedRole === "Admin")
    {
      setCurriculumType(CurriculumType.Admin)
    }
    else
    {
      setCurriculumType(CurriculumType.None)
    }

  }, [])

  if (curriculumType === CurriculumType.None) return <Spinner type="child" />
  if (curriculumType === CurriculumType.StudentExtended) return <StudentExtendedCurriculum />
  if (curriculumType === CurriculumType.StudentNormal) return <StudentCurriculum />
  if (curriculumType === CurriculumType.Parent) return <ParentCurriculum />
  if (curriculumType === CurriculumType.Admin) return <AdminCurriculum />
}
